<template>
  <div
    class="block-auth-login-magic-expired"
    :class="{
      'is-on-grid': isOnGrid,
    }"
  >
    <div class="block-auth-login-magic-expired__inner">
      <AtomTextHeading
        v-if="title"
        :text="title"
        font-size="h2"
        class="block-auth-login-magic-expired__title"
      />

      <AtomTextRichtext
        v-if="text"
        :html="text"
        class="block-auth-login-magi-expiredc__text"
      />

      <AtomButton
        :text="buttonText"
        class="block-auth-login-magic-expired__button"
        :callback="submitCallback"
      />
    </div>
  </div>
</template>

<script setup>
defineProps({
    /*
          Layout
    */
    isOnGrid: {
        type: Boolean,
        default: false,
    },

    buttonAlignment: {
        type: String,
        default: 'left',
        validator: (value) => ['left', 'center', 'right'].includes(value),
    },

    /*
        Content
    */
    title: {
        type: String,
        default: '',
    },

    text: {
        type: String,
        default: '',
    },

    formFields: {
        type: Array,
        default: () => [],
    },

    errorMessage: {
        type: String,
        default: '',
    },

    successMessage: {
        type: String,
        default: '',
    },

    /*
        Links
    */
    additionalLink: {
        type: String,
        default: '',
    },

    additionalLinkText: {
        type: String,
        default: '',
    },

    additionalLinkTooltip: {
        type: String,
        default: '',
    },

    buttonLink: {
        type: String,
        default: '',
    },

    buttonText: {
        type: String,
        default: '',
    },
});

const submitCallback = async () => {
    const localePath = useLocalePath();
    navigateTo(localePath('login-magic'));
};
</script>

<style lang="scss" scoped>
.block-auth-login-magic-expired {
    @include wrapper-center;

    &.is-on-grid {
        @include wrapper-layout;
        @include grid-layout();
    }
}

.block-auth-login-magic-expired__inner {
    @include box-default;
    @include default-content-columns('narrow');
    position: relative;

    display: flex;
    width: 100%;
    flex-direction: column;
    row-gap: 20px;
}

.block-auth-login-magic-expired__button {
    align-self: flex-start;
}
</style>
